import { ReactNode } from 'react';

interface IWdsSectionProps {
  isLoading: boolean;
  hasChats: boolean;
  hasVisibleChats: boolean;
  isUnreadFilterEnabled: boolean;
  children: ReactNode;
}

/** Умный раздел обращений из WDS-виджета. */
export function WdsSection({
  isLoading,
  hasChats,
  hasVisibleChats,
  isUnreadFilterEnabled,
  children
}: IWdsSectionProps) {
  if (isLoading && !hasChats) {
    return (
      <div className="telegram-chat-list__placeholder">
        <span className="telegram-chat-list__pulse" aria-hidden="true" />
        <strong>Загружаем WDS-чаты</strong>
        <p>Подготавливаем список посетителей сайта, написавших в виджет.</p>
      </div>
    );
  }

  if (!isLoading && !hasChats) {
    return (
      <div className="telegram-chat-list__placeholder">
        <span className="telegram-chat-list__pulse" aria-hidden="true" />
        <strong>WDS-чаты пока пусты</strong>
        <p>Новые обращения из виджета сайта появятся здесь автоматически.</p>
      </div>
    );
  }

  if (hasChats && !hasVisibleChats) {
    return (
      <div className="telegram-chat-list__placeholder telegram-chat-list__placeholder--compact">
        <strong>{isUnreadFilterEnabled ? 'Непрочитанных WDS-чатов нет' : 'Ничего не найдено'}</strong>
        <p>{isUnreadFilterEnabled ? 'Отключите фильтр или дождитесь новых сообщений из виджета.' : 'Измените строку поиска, чтобы увидеть нужный диалог.'}</p>
      </div>
    );
  }

  return <div className="telegram-chat-list__items">{children}</div>;
}
